import { apis } from "service";

const COMMON_URL = `https://atydwnieukubkdyahwoi.supabase.co/rest/v1/`;

const API_URLS = {
  POST_CATEGORY_RESULTS: `${COMMON_URL}categoryResults`,
  POST_METRICS: `${COMMON_URL}metrics`,
};

export const postCategoryResults = (payload) =>
  apis.post(API_URLS.POST_CATEGORY_RESULTS, payload);

export const postMetrics = (payload) =>
  apis.post(API_URLS.POST_METRICS, payload);
